import { SurveyAnswerValue } from "@/modules/session-survey/types/SurveyAnswerValue";
import { SurveyQuestion } from "@/modules/session-survey/types/SurveyQuestion";

const DECLINED_LABEL = "no";

/**
 * Whether the member answered "No" to the continue-with-coach question.
 * The question is identified by the `isContinueWithCoach` client-metadata
 * flag Glepnir sets on exactly one question. Option values are opaque
 * numeric strings, so the declined choice is matched by its label
 * starting with "No", surviving copy rewording in Nova. A missing
 * question or a skipped answer reads as not declined (the default
 * confirmation path).
 */
export const isContinueWithCoachDeclined = (
  questions: SurveyQuestion[],
  answers: Record<string, SurveyAnswerValue | undefined>,
): boolean => {
  const continueWithCoachQuestion = questions.find(
    (question) => question.clientMetadata?.isContinueWithCoach,
  );

  if (!continueWithCoachQuestion) return false;

  const answer = answers[continueWithCoachQuestion.id];

  if (typeof answer !== "string") return false;

  const selectedOption = continueWithCoachQuestion.options?.find(
    (option) => option.value === answer,
  );

  return (
    selectedOption !== undefined &&
    selectedOption.label.trim().toLowerCase().startsWith(DECLINED_LABEL)
  );
};
